<!-- TrainingInstitutionDetail.vue -->
<template>
    <myDialog 
        :isDialog="dialogVisible" 
        :title="title" 
        :width="'1200px'"
        @handleClose="handleClose"
    >
        <template slot="content">
            <!-- 教学点列表-->
            <div class="detail-content">
                <myTableSearch 
                    :isOperate="false" 
                    :formData="formData"
                    :tableLabel="tableLabel"
                    :queryFn="queryFn"
                    :queryParams="queryParams"
                    @successQuery="successQuery" 
                    :searchColLg="6" 
                    ref="tableRef" 
                    dataRow="rows"
                    :isTool="false"
                    :isIndex="true"
                    :isPagination="false"
                >
                </myTableSearch>
            </div>
        </template>
        
        <!-- 底部按钮（可选） -->
        <template slot="footer">
            <div class="dialog-footer">
                <el-button @click="handleClose">关闭</el-button>
                <!-- 可以添加其他操作按钮 -->
                <!-- <el-button type="primary" @click="handleEdit">编辑</el-button> -->
            </div>
        </template>
    </myDialog>
</template>

<script>
import '@/assets/css/base.css'
import { getTrainingInstitutionTeachingPointList } from '@/api/training'
export default {
name: 'teachingPoint',
props: {
    isDialog: {
        type: [String, Boolean],
        default: false
    },
    title: {
        type: String,
        default: ''
    },
    institutionId:{
        type: String,
        default:""
    }
},
data() {
    return {
        dialogVisible: false, // 控制弹窗显示
        currentInstitutionId: '', // 当前统一社会信用代码
        formData: [], // 搜索表单数据（空数组，不需要搜索功能）
        queryParams: {},
        tableLabel: [
            {
                prop: 'pointName',
                label: '教学点名称',
                minWidth: 200
            },
            {
                prop: 'pointAddress',
                label: '教学点地址',
                minWidth: 300
            },
            {
                prop: 'contactPerson',
                label: '联系人',
                minWidth: 120
            },
            {
                prop: 'contactPhone',
                label: '联系电话',
                minWidth: 150
            }
        ],
    }
},
methods: {
    // 打开弹窗
    openDialog(row) {
        this.dialogVisible = true
        // 优先使用传入的 row 参数中的 institutionId，如果没有则使用 props
        const id = (row && row.institutionId) ? row.institutionId : this.institutionId
        if (id) {
            this.loadTeachingPointData(id)
        } else {
            // 如果没有 id，等待 props 更新后再加载
            this.$nextTick(() => {
                if (this.institutionId) {
                    this.loadTeachingPointData(this.institutionId)
                }
            })
        }
    },
    
     // 关闭弹窗
     handleClose() {
        this.dialogVisible = false
        this.currentInstitutionId = ''
        // 可以通知父组件弹窗已关闭
        this.$emit('dialog-closed')
    },
    
    // 查询函数 - 供myTableSearch组件调用
    queryFn(queryParams) {
        // 合并统一社会信用代码到查询参数中
        const params = {
            ...queryParams,
            institutionId: this.currentInstitutionId
        }
        return getTrainingInstitutionTeachingPointList(params).then(res => {
            // 如果返回的data是数组，需要转换为组件期望的格式
            if (res && res.code === 200 && Array.isArray(res.data)) {
                return {
                    ...res,
                    data: {
                        rows: res.data,
                        total: res.data.length
                    }
                }
            }
            return res
        })
    },
    
    // 查询成功回调
    successQuery(data) {
        // 可以在这里处理查询成功后的逻辑
        console.log('教学点列表查询成功', data)
    },
    
    //加载数据列表
    async loadTeachingPointData(institutionId) {
        this.currentInstitutionId = institutionId
        // 触发表格刷新
        this.$nextTick(() => {
            if (this.$refs.tableRef) {
                this.$refs.tableRef.initTableData({}, false)
            }
        })
    },
    

},
// 监听父组件传递的isDialog变化（如果使用props控制）
watch: {
    isDialog: {
        handler(newVal) {
            // 如果isDialog是Boolean类型
            if (typeof newVal === 'boolean') {
                this.dialogVisible = newVal
            }
            // 如果isDialog是String类型（例如："true-机构基本信息"）
            else if (typeof newVal === 'string') {
                this.dialogVisible = newVal.includes('true')
            }
        },
        immediate: true
    }
}
}
</script>


<style lang="scss" scoped>
.myDialog {
/deep/ .el-dialog__header {
    height: 48px;
    line-height: 48px;
    font-size: 17px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: var(--vt-c-blue)!important;
}
        
/deep/ .el-dialog__title {
    color: #ffffff !important;
    font-weight: 700;
    font-size: 17px;
}
        
/deep/ .el-dialog__headerbtn {
    filter: brightness(0) invert(1) !important;
}
}

.detail-content {
    width: 100%;
    height: 100%;

}
</style>
